'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMessageBot, iconMessageBotTag } from '@ni/nimble-components/dist/esm/icons/message-bot';
import { wrap } from '../../utilities/react-wrapper';

export type { IconMessageBot };
export { iconMessageBotTag };
export const NimbleIconMessageBot = wrap(IconMessageBot);